import { render, staticRenderFns } from "./BetHistoryList.vue?vue&type=template&id=63bd6775&scoped=true&"
import script from "./BetHistoryList.vue?vue&type=script&lang=js&"
export * from "./BetHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./BetHistoryList.vue?vue&type=style&index=0&id=63bd6775&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd6775",
  null
  
)

export default component.exports